import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './locales/ja.json';
import en from './locales/en.json';

const STORAGE_KEY = 'd-orca.lang';

/**
 * `localStorage` access can throw even when the global exists — Safari private
 * mode, opaque-origin iframes, jsdom, storage disabled by policy. A `typeof`
 * check is not enough; the method calls themselves must be guarded. The stored
 * language is a best-effort preference, so failures fall back silently.
 */
function readSavedLang(): string | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  } catch {
    return null;
  }
}

function saveLang(lng: string): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* storage unavailable — language preference just isn't persisted */
  }
}

const saved = readSavedLang();
const initial = saved === 'en' || saved === 'ja' ? saved : 'en';

void i18n.use(initReactI18next).init({
  resources: { ja: { translation: ja }, en: { translation: en } },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', lng);
  }
  saveLang(lng);
});

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', initial);
}

export { i18n };
